export default __webpack_public_path__ + "static/media/Group8877.3debfb5e.svg";